
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tentang-kurikulum-merdeka",
      function () {
        return require("private-next-pages/tentang-kurikulum-merdeka/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tentang-kurikulum-merdeka"])
      });
    }
  